import apiClient from '../connections/api'

export default {
    uploadManual: (formData) => {
        return apiClient.post('/manuals/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    getAdminManuals: () => {
        return apiClient.get('/manuals/admin')
    },
    getAccessibleUserManual: (roleId) => {
        return apiClient.get('/manuals/user-accessible', {
            params: { roleId }
        })
    },
    toggleManualState: (id, state) => {
        return apiClient.patch(`/manuals/${id}/toggle-state`, { state })
    },
    updateManual: (id, formData) => {
        return apiClient.put(`/manuals/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    deleteManual: (id) => {
        return apiClient.delete(`/manuals/${id}`)
    },
    getManualDownloadUrl: (id) => {
        return apiClient.get(`/manuals/${id}/download-url`)
    }
}
